import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

export class LessonStatusDto {
  @ApiProperty({ description: 'ID du statut', example: '550e8400-e29b-41d4-a716-446655440000', type: 'string' })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({ description: 'Code du statut', example: 'DRAFT', type: 'string' })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ description: 'Nom du statut', example: 'Brouillon', type: 'string' })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ description: 'Description du statut', example: 'Leçon en cours de rédaction', type: 'string' })
  @IsOptional()
  @IsString()
  description?: string
}